import React from 'react'

import style from './style.css'

export default (props) => (
    <div className={`${style.box} ${props.className}`} style={props.style}>
        {props.children}
    </div>
)


// WEBPACK FOOTER //
// ./src/components/atoms/BoxShadow/index.js